import { cmpLog, LOG_TYPE_INFO, LOG_TYPE_ERROR, LOAD_CONSENT, LOAD_CONSENT_FAILED, SUCCESS, FAILED } from './logger';
var PARTNER = 'DATA_BLOCK_ON_CONSENT';
export default (function (tcData, success) {
  cmpLog(LOG_TYPE_INFO, "".concat(LOAD_CONSENT, " [").concat(PARTNER, "]"), success ? SUCCESS : FAILED);

  if (success) {
    if (tcData.eventStatus === 'cmpuishown') {
      document.body.style.overflowY = 'hidden';
    }

    if (tcData.eventStatus === 'useractioncomplete') {
      document.body.style.overflowY = 'auto';
    }
  } else {
    cmpLog(LOG_TYPE_ERROR, "".concat(LOAD_CONSENT_FAILED, " ").concat(PARTNER));
  }
});